import i18next from 'i18next';

i18next.addResources('es', 'MonthPicker', {
  selectLabel: 'Seleccionar {{month}} de {{year}}'
});
